import { Button, Typography } from "antd";
import { useContext } from "react";
import styled from "styled-components";
import { FluxoResposta } from "../cadastroCotaUsuario.types";
import { OnboardingFrame, OnboardingNavigationContext } from "../utils";

interface Props {
  fluxo: FluxoResposta;
  submitting: boolean;
  onConcluir: (payload: Record<string, unknown>) => Promise<void>;
}

const Conteudo = styled.div`
  display: grid;
  gap: 24px;
  max-width: 680px;

  .descricao {
    color: #42535b;
    font-size: 16px;
    line-height: 1.65;
    margin: 0;
  }

  .rodape {
    border-top: 1px solid #e1e8ea;
    padding-top: 20px;
  }
`;

export function EtapaPagamentoConfirmado({
  fluxo,
  submitting,
  onConcluir,
}: Props) {
  const { onVoltar } = useContext(OnboardingNavigationContext);

  return (
    <OnboardingFrame fluxo={fluxo} title="Pagamento confirmado!">
      <Conteudo>
        <Typography.Paragraph className="descricao">
          Sua assinatura foi ativada com sucesso.
        </Typography.Paragraph>

        <Typography.Paragraph className="descricao">
          Agora, vamos completar algumas informações da sua cota para preparar o anúncio para publicação.
        </Typography.Paragraph>

        <Button
          type="primary"
          size="large"
          loading={submitting}
          onClick={() => onConcluir({ acao: "CONTINUAR_CADASTRO" })}
          style={{ minWidth: 220, borderRadius: 999, background: "#003644" }}
        >
          Continuar cadastro
        </Button>

        {onVoltar ? (
          <div className="rodape">
            <Button size="large" disabled={submitting} onClick={onVoltar}>
              Voltar
            </Button>
          </div>
        ) : null}
      </Conteudo>
    </OnboardingFrame>
  );
}
